import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=5e2f559b&scoped=true&"
import script from "./detail.js?vue&type=script&lang=js&"
export * from "./detail.js?vue&type=script&lang=js&"
import style0 from "./detail.scss?vue&type=style&index=0&id=5e2f559b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e2f559b",
  null
  
)

export default component.exports